import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20educational%20background%20with%20warm%20amber%20and%20cream%20tones%2C%20soft%20gradient%20lighting%2C%20abstract%20geometric%20shapes%20inspired%20by%20Japanese%20and%20Korean%20design%20elements%2C%20clean%20aesthetic%2C%20subtle%20paper%20texture%2C%20elegant%20scholarly%20atmosphere%2C%20no%20text%2C%20high%20quality%20editorial%20composition&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <div className="max-w-3xl mx-auto">
          <span className="animate-fade-in inline-block px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-sm font-medium mb-6">
            日韩一区二区 · 成人教育权威平台
          </span>

          <h1 className="animate-fade-in-up stagger-1 text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
            汇聚日韩顶尖资源
            <br />
            <span className="text-accent-400">精准匹配</span>你的学习需求
          </h1>

          <p className="animate-fade-in-up stagger-2 text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            日韩一区二区成人教育平台，专为成人学习者打造。
            覆盖语言学习、职场培训、文化教育、学历提升等多元课程，
            随时随地开启你的日韩学习新旅程。
          </p>

          <div className="animate-fade-in-up stagger-3 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/zone-jp"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              探索日本区课程
            </Link>
            <Link
              to="/category/zone-kr"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold text-base border border-background-50/30 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap"
            >
              探索韩国区课程
            </Link>
          </div>

          <div className="animate-fade-in-up stagger-4 flex items-center justify-center gap-8 mt-12">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">50,000+</p>
              <p className="text-sm text-background-50/70 mt-1">注册学员</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">200+</p>
              <p className="text-sm text-background-50/70 mt-1">精品课程</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">98%</p>
              <p className="text-sm text-background-50/70 mt-1">满意度</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}